// @flow

const transition = (
    oldEl: HTMLElement,
    newEl: HTMLElement,
    duration: number = 350
): Promise<any> => {
    return new Promise((resolve: () => void) => {
        const animation = "fade";

        newEl.classList.add(`${animation}-enter`);
        oldEl.classList.add(`${animation}-exit`);

        oldEl.insertAdjacentElement("afterend", newEl);

        requestAnimationFrame(() => {
            newEl.classList.add(`${animation}-enter-active`);
            oldEl.classList.add(`${animation}-exit-active`);

            setTimeout(() => {
                oldEl.remove();
                newEl.classList.remove(`${animation}-enter`);
                newEl.classList.remove(`${animation}-enter-active`);
                resolve();
            }, duration);
        });
    });
};

export default transition;
